import type { Melding } from './rooster-types'

const OPVALLENDE_SOORTEN: ReadonlySet<string> = new Set([
  'nieuwe_medewerker',
  'nieuwe_groep',
  'reeks_verdwenen',
  'veel_weken_vervallen',
])

export interface Meldingblokken {
  aandacht: Melding[]
  bekeken: Melding[]
}

export function isOpvallend(melding: Melding): boolean {
  return OPVALLENDE_SOORTEN.has(melding.soort)
}

/**
 * De parser levert de meldingen in de volgorde waarin hij ze in het blad tegenkomt.
 * Een rij die ergens halverwege wordt ingevoegd zou daarmee de hele lijst laten
 * verspringen, terwijl een tweede upload juist herkenbaar moet blijven. Vandaar een
 * eigen volgorde: eerst wat opvalt, daarbinnen op soort en onderwerp.
 */
export function sorteerMeldingen(meldingen: Melding[]): Melding[] {
  return [...meldingen].sort((links, rechts) => {
    if (isOpvallend(links) !== isOpvallend(rechts)) return isOpvallend(links) ? -1 : 1
    if (links.soort !== rechts.soort) return links.soort.localeCompare(rechts.soort, 'nl')
    return links.onderwerp.localeCompare(rechts.onderwerp, 'nl')
  })
}

export function verdeelMeldingen(meldingen: Melding[]): Meldingblokken {
  const gesorteerd = sorteerMeldingen(meldingen)

  return {
    aandacht: gesorteerd.filter((melding) => !melding.afgevinkt),
    bekeken: gesorteerd.filter((melding) => melding.afgevinkt),
  }
}
